
import { tr } from './translate'
import Check from '@/assets/icons/support_ticket/check.svg?inline'

export default {
  components: { Check },
  props: {
    config: {
      type: Object,
      default: null,
    },
    stepKeys: {
      type: Array,
      required: true,
    },
    currentIdx: {
      type: Number,
      required: true,
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
  },
}
